import { makeAutoObservable, toJS } from 'mobx';

class Report {
  unplainedIsLockedPeriod = false;
  unplainedIsOpenExportPDF = false;
  unplainedIsConversionReportType = false;
  unplainedIsComparisonReport = false;

  constructor() {
    makeAutoObservable(this);

    this.setIsLockedPeriod = this.setIsLockedPeriod.bind(this);
    this.setIsOpenExportPDF = this.setIsOpenExportPDF.bind(this);
    this.setIsConversionReportType = this.setIsConversionReportType.bind(this);
    this.setIsComparisonReport = this.setIsComparisonReport.bind(this);
  }

  setIsComparisonReport(payload) {
    this.unplainedIsComparisonReport = payload;
  }

  setIsLockedPeriod(_isLockedPeriod) {
    this.unplainedIsLockedPeriod = _isLockedPeriod;
  }

  setIsOpenExportPDF(payload) {
    this.unplainedIsOpenExportPDF = payload;
  }

  get isLockedPeriod() {
    return toJS(this.unplainedIsLockedPeriod);
  }

  get isOpenExportPDF() {
    return toJS(this.unplainedIsOpenExportPDF);
  }

  setIsConversionReportType(payload) {
    this.unplainedIsConversionReportType = payload;
  }

  get isConversionReportType() {
    return toJS(this.unplainedIsConversionReportType);
  }

  get isComparisonReport() {
    return toJS(this.unplainedIsComparisonReport);
  }
}

const reportStore = new Report();

export default reportStore;
